import { render, staticRenderFns } from "./LbaTableImport.vue?vue&type=template&id=33e59d8c&scoped=true"
import script from "./LbaTableImport.vue?vue&type=script&lang=js"
export * from "./LbaTableImport.vue?vue&type=script&lang=js"
import style0 from "./LbaTableImport.vue?vue&type=style&index=0&id=33e59d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e59d8c",
  null
  
)

export default component.exports